import { requestJson } from "./client";
import type { LoginCredentials, LoginResponse } from "@/types/auth";

export function signIn(credentials: LoginCredentials) {
  return requestJson<LoginResponse>("/api/token/", {
    method: "POST",
    body: JSON.stringify(credentials),
  });
}
